export const FILE_ACTION = {
  MANAGE_FILES: 'manageFiles',
  VIEW_SCHEMA: 'viewSchema',
};

export const FILE_DATA_CONNECTOR_LABEL = 'Imported Files';
export const DATASETS_CONNECTOR_LABEL = 'Datasets';
export const FILE_DATA_SYNAPSE_NAME = 'filedata';
